export const calculateTotalPrice = (items = []) => {
  return items.reduce((total, item) => {
    const quantity = Number(item.quantity) || 0
    const unitPrice = Number(item.unit_price) || 0
    return total + quantity * unitPrice
  }, 0)
}
